const initialState = {
    user: {},
  };
  
  const loginuserReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_LOGIN_USER_DETAIL':
        return {
          ...state,
          user: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default loginuserReducer;
  